import React, { FC, ReactNode } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface SpinnerProps {
  label?: ReactNode;
}

export const Spinner: FC<SpinnerProps> = ({ label }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}>
      <CircularProgress />
      {label && (
        <Typography
          variant="MHCaption"
          color="text.secondary"
          component="div"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {label}
        </Typography>
      )}
    </Box>
  );
};
